import { getPieRadius } from '../../utils/chart'; // 没有legend时的饼图半径与有legend时的饼图半径比

export var withLegendRatio = 1.166;
export default function (chart, orient) {
  var radius = getPieRadius(chart.radius);
  chart.radius[1] = radius.outside / withLegendRatio + "%";

  if (orient === 'vertical') {
    chart.center = ['50%', '36%'];
  } else {
    chart.center = ['38%', '50%'];
  }
}